import React from "react";
import styled from "styled-components";

import { Icon } from "js/Components/Icon";

const BreadcrumbContainer = styled.span`
    width: max-content;
    display: inline-flex;
    align-items: center;
    gap: 2px;
`;

const BreadcrumbChevron = styled(Icon)`
    &&& .bai-icon {
        margin-right: 0;
    }

    margin-right: -2px;
`;

export interface LibraryBreadcrumbProps {
    pathParts: string[];
    iconColor?: string;
}

export function LibraryBreadcrumb({ pathParts, iconColor }: LibraryBreadcrumbProps) {
    return (
        <BreadcrumbContainer>
            {pathParts.map((part, i) => (
                <React.Fragment key={`${part}-${i}`}>
                    {i > 0 && <BreadcrumbChevron small {...(iconColor ? { color: iconColor } : { white: true })}>chevron_right</BreadcrumbChevron>}
                    <span style={{ textTransform: "capitalize" }}>{part}</span>
                </React.Fragment>
            ))}
        </BreadcrumbContainer>
    );
}
